export default {
  name: 'ScriptPackAbout',
};
